<template>
  <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
    <div class="banner perBan">
      <img :src="banners.image" alt="">
      <div class="w1440">
        <div class="txt">
          <p class="fnt_52">
            {{ globalDataArray.siteTemplateLanguage.banner_welcome }}
            <template v-if="saitiAccessInfo.username!=''&&saitiAccessInfo.username!=null">
              {{ saitiAccessInfo.username }}
            </template>
            <template v-else-if="saitiAccessInfo.nickname!=''&&saitiAccessInfo.nickname!=null">
              {{ saitiAccessInfo.nickname }}
            </template>
          </p>
          <span class="fnt_18 mail" v-if="saitiAccessInfo.email!=''&&saitiAccessInfo.email!=null">
            {{ saitiAccessInfo.email }}
          </span>
          <span class="fnt_18" v-else-if="saitiAccessInfo.phone!=''&&saitiAccessInfo.phone!=null">
            {{ saitiAccessInfo.phone }}
          </span>
        </div>
      </div>
    </div>

    <div class="personPage">
      <div class="cf w1440">
        <div class="personLeft">
          <personmenu />
        </div>

        <div class="personRight">
          <div class="tit fnt_32">{{ globalDataArray.siteTemplateLanguage.person_message_record }}</div>

          <!-- 选择统计信息 -->
          <div v-if="allSelectedIds.length > 0" class="selection-info">
            <span class="selection-count">
              {{ globalDataArray.siteTemplateLanguage.selected_count.replace('{num}', allSelectedIds.length) }}
            </span>
            <a-button type="link" @click="clearAllSelection">
              {{ globalDataArray.siteTemplateLanguage.clear_selection_tips }}
            </a-button>
          </div>

          <div class="tool-bar">
            <a-button type="primary" @click="batchMarkRead" :disabled="allSelectedIds.length === 0 || loading">{{ globalDataArray.siteTemplateLanguage.batch_mark_read }}</a-button>
            <a-button type="danger" @click="batchDelete" :disabled="allSelectedIds.length === 0 || loading">{{ globalDataArray.siteTemplateLanguage.batch_delete }}</a-button>
          </div>

          <div class="antDesignTable">
            <a-table
              row-key="id"
              :scroll="{x:true}"
              :columns="columns"
              :data-source="list"
              :pagination="paginationOpt"
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
              :loading="loading"
              class="j-table-force-nowrap"
            >
              <template slot="tit" slot-scope="text, record">
                <span @click="seeInfo(record)" class="compNameBtn">
                  {{ text }}
                  <span v-if="record.readFlag=='0'" class="unread-dot"></span>
                </span>
              </template>

              <template slot="action" slot-scope="text, record">
                <span @click="delMsgFun(record.id)" class="compExamineBtn">{{ globalDataArray.siteTemplateLanguage.delete }}</span>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>

    <personmsg :personmsg.sync="personmsg" :curid="curid" />
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue'
import Cookies from 'js-cookie'
import { getAdList } from '@/api/api'
import { MessageRecordList, deleteMessageRecord, batchMarkReadMessage, batchDeleteMessageRecord } from '@/api/person/person'
import personmsg from '@/components/global/personmsg'
import dayjs from 'dayjs'

export default {
  name: 'Myapply',
  components: {
    personmsg
  },
  data() {
    return {
      title: this.globalDataArray.siteInfo.title,
      description: this.globalDataArray.siteInfo.description,
      keywords: this.globalDataArray.siteInfo.keywords,

      loading: false,
      paginationOpt: {
        current: 1,
        defaultCurrent: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0,
        hideOnSinglePage: true,
        onChange: (current, size) => {
          this.defaultPageSize = size
          this.paginationOpt.current = current
          this.MessageRecordList()
        },
        onShowSizeChange: (current, pageSize) => {
          this.paginationOpt.pageSize = pageSize
        }
      },
      saitiAccessInfo: '',
      // 全局选择状态管理
      allSelectedIds: [],

      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 80,
          align: 'center',
          customRender: (text, record, index) => {
            return ((this.paginationOpt.current - 1) * this.paginationOpt.pageSize + index + 1)
          }
        },
        {
          title: '消息发布者',
          align: 'center',
          dataIndex: 'sender',
          sorter: (a, b) => a.sender.length - b.sender.length
        },
        {
          title: '标题',
          align: 'center',
          dataIndex: 'title',
          scopedSlots: { customRender: 'tit' },
          sorter: (a, b) => a.title.length - b.title.length
        },
        {
          title: '发布时间',
          align: 'center',
          dataIndex: 'createTime',
          sorter: (a, b) => dayjs(a.createTime, 'DD-MM-YYYY HH:mm:ss').unix() - dayjs(b.createTime, 'DD-MM-YYYY HH:mm:ss').unix()
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],

      list: [],

      personmsg: false,
      curid: {},
      banners: {}
    }
  },
  computed: {
    // 计算当前页选中的ID
    selectedRowKeys() {
      return this.list.filter(item => this.allSelectedIds.includes(item.id)).map(item => item.id)
    }
  },
  created() {
    this.init()
  },
  mounted() {
    if (Cookies.get('saiti_access_info') != '' && Cookies.get('saiti_access_info') != undefined && Cookies.get('saiti_access_info') != null) {
      this.saitiAccessInfo = JSON.parse(Cookies.get('saiti_access_info'))
    }
  },
  methods: {
    init() {
      this.getAdList()
      this.tableHeader()
      this.MessageRecordList()
      if (Cookies.get('saiti_access_info') != '' && Cookies.get('saiti_access_info') != undefined && Cookies.get('saiti_access_info') != null) {
        this.saitiAccessInfo = JSON.parse(Cookies.get('saiti_access_info'))
      }
    },
    tableHeader() {
      const that = this
      that.columns[0].title = that.globalDataArray.siteTemplateLanguage.person_table_number
      that.columns[1].title = that.globalDataArray.siteTemplateLanguage.msg_publisher
      that.columns[2].title = that.globalDataArray.siteTemplateLanguage.message_title
      that.columns[3].title = that.globalDataArray.siteTemplateLanguage.publish_time
      that.columns[4].title = that.globalDataArray.siteTemplateLanguage.person_table_controls
    },
    MessageRecordList() {
      const that = this
      that.loading = true
      const param = 'page=' + that.paginationOpt.current + '&pageSize=' + that.paginationOpt.defaultPageSize
      MessageRecordList(param).then(res => {
        that.loading = false
        if (res.success) {
          that.list = res.result.records
          that.paginationOpt.total = res.result.total
        }
      }).catch(() => {
        that.loading = false
      })
    },
    getAdList() {
      const that = this
      const adParam = 'alias=person_banner'
      getAdList(adParam).then(res => {
        if (res.success) {
          that.banners = res.result[0]
        }
      })
    },
    seeInfo(record) {
      this.personmsg = true
      this.curid = JSON.parse(JSON.stringify(record))

      // 将消息标记为已读
      if (record.readFlag === '0') {
        this.markMessageAsRead([record.id], false) // Don't show notification for single message
      }
    },
    markMessageAsRead(ids, showNotification = true) {
      batchMarkReadMessage(ids).then(res => {
        if (res.success) {
          // 更新本地数据状态
          this.list.forEach(item => {
            if (ids.includes(item.id)) {
              item.readFlag = '1'
            }
          })

          if (showNotification) {
            this.$message.success(this.globalDataArray.siteTemplateLanguage.mark_read_success.replace('{num}', ids.length))
          }

          // 清空选择
          this.allSelectedIds = []

          // 刷新数据列表
          this.list = [...this.list]
        }
      })
    },
    onSelectChange(selectedRowKeys) {
      // 处理表格全选/取消全选当前页
      // 当前页所有ID
      const currentPageIds = this.list.map(item => item.id)
      // 1. 先把当前页所有ID从全局移除
      this.allSelectedIds = this.allSelectedIds.filter(id => !currentPageIds.includes(id))
      // 2. 再把当前页选中的ID加入全局
      this.allSelectedIds.push(...selectedRowKeys)
    },
    selectAllUnreadCurrentPage() {
      // 获取当前页面所有未读消息的ID
      const unreadIds = this.list.filter(item => item.readFlag === '0').map(item => item.id)

      if (unreadIds.length === 0) {
        this.$message.info('当前页面没有未读消息')
        return
      }

      // 添加到全局选择中（避免重复）
      unreadIds.forEach(id => {
        if (!this.allSelectedIds.includes(id)) {
          this.allSelectedIds.push(id)
        }
      })

      this.$message.success(`已选择当前页面的 ${unreadIds.length} 条未读消息`)
    },
    selectAllUnread() {
      const that = this
      that.loading = true

      // 获取所有未读消息
      const getAllUnreadMessages = (page = 1, allUnreadIds = []) => {
        const param = `page=${page}&pageSize=100` // 使用较大的页面大小
        MessageRecordList(param).then(res => {
          if (res.success && res.result.records.length > 0) {
            // 收集当前页的未读消息ID
            const currentPageUnreadIds = res.result.records
              .filter(item => item.readFlag === '0')
              .map(item => item.id)

            allUnreadIds.push(...currentPageUnreadIds)

            // 如果还有更多页面，继续获取
            if (res.result.records.length === 100 && page * 100 < res.result.total) {
              getAllUnreadMessages(page + 1, allUnreadIds)
            } else {
              // 完成所有页面的获取
              that.loading = false

              if (allUnreadIds.length === 0) {
                that.$message.info('没有未读消息')
                return
              }

              // 添加到全局选择中（避免重复）
              allUnreadIds.forEach(id => {
                if (!that.allSelectedIds.includes(id)) {
                  that.allSelectedIds.push(id)
                }
              })

              that.$message.success(`已选择所有 ${allUnreadIds.length} 条未读消息`)
            }
          } else {
            that.loading = false
            if (allUnreadIds.length === 0) {
              that.$message.info('没有未读消息')
            } else {
              that.$message.success(`已选择所有 ${allUnreadIds.length} 条未读消息`)
            }
          }
        }).catch(() => {
          that.loading = false
          that.$message.error('获取未读消息失败')
        })
      }

      getAllUnreadMessages()
    },
    clearAllSelection() {
      this.allSelectedIds = []
      this.$message.info(this.globalDataArray.siteTemplateLanguage.clear_selection_tips)
    },
    batchMarkRead() {
      const that = this
      if (that.allSelectedIds.length === 0) {
        this.$message.warning(that.globalDataArray.siteTemplateLanguage.select_at_least_one)
        return
      }

      Modal.confirm({
        title: that.globalDataArray.siteTemplateLanguage.confirm_mark_read.replace('{num}', that.allSelectedIds.length),
        okText: that.globalDataArray.siteTemplateLanguage.verify,
        cancelText: that.globalDataArray.siteTemplateLanguage.cancel,
        onOk() {
          that.loading = true
          that.markMessageAsRead(that.allSelectedIds, true)
          setTimeout(() => {
            that.loading = false
          }, 500)
        }
      })
    },
    batchDelete() {
      const that = this
      if (that.allSelectedIds.length === 0) {
        this.$message.warning(that.globalDataArray.siteTemplateLanguage.select_at_least_one)
        return
      }

      Modal.confirm({
        title: that.globalDataArray.siteTemplateLanguage.confirm_delete.replace('{num}', that.allSelectedIds.length),
        content: '',
        okText: that.globalDataArray.siteTemplateLanguage.verify,
        cancelText: that.globalDataArray.siteTemplateLanguage.cancel,
        onOk() {
          that.loading = true
          const param = 'ids=' + that.allSelectedIds.join(',')
          batchDeleteMessageRecord(param).then(res => {
            that.loading = false
            if (res.success) {
              that.$message.success(that.globalDataArray.siteTemplateLanguage.delete_success.replace('{num}', that.allSelectedIds.length))
              that.allSelectedIds = []
              that.MessageRecordList()
            }
          }).catch(() => {
            that.loading = false
          })
        }
      })
    },
    delMsgFun(id) {
      const that = this
      Modal.confirm({
        title: that.globalDataArray.siteTemplateLanguage.person_delete_message,
        content: '',
        okText: that.globalDataArray.siteTemplateLanguage.verify,
        cancelText: that.globalDataArray.siteTemplateLanguage.cancel,
        onOk() {
          that.loading = true
          const param = 'id=' + id
          deleteMessageRecord(param).then(res => {
            that.loading = false
            if (res.success) {
              that.$message.success(that.globalDataArray.siteTemplateLanguage.delete_success)
              // 更新未读消息计数
              const msg = that.list.find(item => item.id === id)
              if (msg && msg.readFlag === '0') {
                const msgnum = that.$store.state.msgnum - 1
                that.$store.commit('setSiteMsgnum', Math.max(0, msgnum))
              }
              that.MessageRecordList()
            }
          }).catch(() => {
            that.loading = false
          })
        }
      })
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords }
      ]
    }
  }
}
</script>
<style>
@import '@/assets/css/person.css';
</style>

<style lang="scss" scoped>
.tool-bar {
  margin-bottom: 16px;
  .ant-btn {
    margin-right: 8px;
  }
}

.compNameBtn {
  cursor: pointer;
  color: #1890ff;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  transition: color 0.3s;
  position: relative;
  padding-right: 15px;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }

  .unread-dot {
    position: absolute;
    top: 0;
    right: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #f5222d;
  }
}

.compExamineBtn {
  color: #ff4d4f;
  cursor: pointer;

  &:hover {
    color: #ff7875;
    text-decoration: underline;
  }
}
</style>
